import moduleInitializer from './module-initializer'
import config from '../config'

moduleInitializer(config.modules, config.initializerOpts)
